// 浏览器 h5打开 app 页面，营销跳转场景使用
import { AbTestEnum } from '@/api/user/types';
import { PageVersionTypeEnums, EvokeAppTypeEnums } from '@/views_v2/new-redirect/types';
import { RouteConfig } from 'vue-router';
import { RouterV2Enum, WHITE_LIST } from '../router-names';

export default (): RouteConfig[] => ([
  {
    path: RouterV2Enum.newRedirect,
    name: 'newRedirect',
    component: () => import(/* webpackChunkName: "new-redirect" */ '@/views_v2/new-redirect'),
    props: (route) => ({
      phone: String(route.query.phone || ''),
      source: String(route.query.source || ''),
      // 是否开启 abtest，默认开启 abtest。如果不开启，需要在链接上加上 isAbtest=false 参数，走新版本带登录样式且在h5流程里面做个人基本信息的填写
      isAbtest: Boolean(route.query.isAbtest === undefined || route.query.isAbtest === 'true' || ''),
      // 是否一进页面 直接跳转提现页, 该模式会开启 abtest（40%），针对有额度 可以提现的用户，直接跳转提现页
      isDirectApply: Boolean(route.query.isDirectApply === 'true' || ''),
      // 是否一进入页面立即唤起app, 默认链接上无配置项，表示立即唤起
      callApp: !(route.query.callApp === 'false'),
    }),
    meta: {
      pageId: 'finance_smsMarketing_landingPage',
      title: '打开哈啰',
      needLogin: WHITE_LIST[RouterV2Enum.newRedirect],
    },
  },
  {
    path: `${RouterV2Enum.marketPage}/:type?`,
    name: 'marketPage',
    component: () => import(/* webpackChunkName: "new-redirect" */ '@/views_v2/new-redirect'),
    props: (route) => ({
      phone: String(route.query.phone || ''),
      source: String(route.query.source || ''),
      type: String(route.query.type || route.params.type || ''),
      isAbtest: [
        PageVersionTypeEnums.BRANDVERSIONWITHLOGIN,
        PageVersionTypeEnums.BRANDVERSIONWITHLOGIN_019,
      ].includes(route.query.type as PageVersionTypeEnums),
      // 是否一进入页面立即唤起app, 默认链接上无配置项，表示立即唤起
      callApp: !(route.query.callApp === 'false'),
    }),
    meta: {
      pageId: 'finance_smsMarketing_landingPage',
      title: '打开哈啰',
      needLogin: WHITE_LIST[RouterV2Enum.marketPage],
    },
  },
  {
    path: RouterV2Enum.guideDownload,
    name: 'guideDownload',
    component: () => import(/* webpackChunkName: "guide-download" */ '@/views_v2/guide-download'),
    meta: {
      pageId: 'finance_guide_downloadApp',
      title: '下载哈啰',
      needLogin: WHITE_LIST[RouterV2Enum.marketPage],
    },
    props: (route) => ({
      /** 是否命中ab */
      hint: String(route.query.hint || AbTestEnum.noHint),
    }),
  },
  {
    path: RouterV2Enum.alipayCreditGuide,
    name: 'alipayCreditGuide',
    component: () => import(/* webpackChunkName: "alipay-credit-guide" */ '@/views_v2/alipay-credit-guide/index.vue'),
    meta: {
      pageId: 'finance_loan_alipayCreditGuide',
      title: '下载哈啰',
    },
    props: (route) => ({
      amount: Number(route.query.amount || 0),
    }),
  },
  {
    path: RouterV2Enum.smsDownload,
    name: RouterV2Enum.smsDownload,
    component: () => import(/* webpackChunkName: "new-redirect" */ '@/views_v2/new-redirect'),
    props: (route) => ({
      phone: String(route.query.phone || ''),
      source: String(route.query.source || ''),
      type: String(route.query.type || ''),
      isAbtest: [
        PageVersionTypeEnums.BRANDVERSIONWITHLOGIN,
        PageVersionTypeEnums.BRANDVERSIONWITHLOGIN_019,
      ].includes(route.query.type as PageVersionTypeEnums),
      evokeAppType: String(route.query.evokeAppType || EvokeAppTypeEnums.HELLO_BIKE),
    }),
    meta: {
      pageId: 'finance_smsMarketing_landingPage',
      title: '下载哈啰',
      needLogin: WHITE_LIST[RouterV2Enum.smsDownload],
    },
  },
  {
    path: `${RouterV2Enum.evokeAppMarket}/:evokeAppType?`,
    /** name用于判断是否属于“主动唤起app”场景，请谨慎修改 */
    name: RouterV2Enum.evokeAppMarket,
    component: () => import(/* webpackChunkName: "new-redirect" */ '@/views_v2/new-redirect'),
    props: (route) => ({
      phone: String(route.query.phone || ''),
      source: String(route.query.source || ''),
      evokeAppType: String(route.params.evokeAppType || EvokeAppTypeEnums.HELLO_BIKE),
    }),
    meta: {
      pageId: 'finance_smsMarketing_landingPage',
      title: '下载哈啰',
      needLogin: WHITE_LIST[RouterV2Enum.smsDownload],
    },
  },
]);
